import { handleResponseOld, makeGet } from './helpers';

/**
 * @category Search API
 * @see fetchSimilarItemsV3
 */
type FetchSimilarItemsParams = {
    authToken: string;
    deployment: string;
    page?: number;
    searchExclusions: number[];
    similarItemInfo: any;
};
/**
 * fetches similar items via Get to Search API
 * @function fetchSimilarItemsV3
 * @category Search API
 * @param {FetchSimilarItemsParams}
 * @see https://api-DEPLOYMENT.liveauctioneers.com/search/similaritems-v3
 * @see https://console.aws.amazon.com/apigateway/home?region=us-east-1#/apis/p8swwvetjb/resources/qa8ucb/methods/GET
 * @see https://github.com/LIVEauctioneers/search-party/blob/master/functions/SimilarItemsV3/main.go
 */
const fetchSimilarItemsV3 = ({
    authToken,
    deployment,
    page,
    similarItemInfo,
    searchExclusions = [],
}: FetchSimilarItemsParams) =>
    new Promise<any>((resolve, reject) => {
        const params = {
            options: {
                auctionHouse: [{ exclude: searchExclusions, include: [] }],
                status: ['upcoming', 'live', 'online'],
            },
            page: page,
            pageSize: 12,
            searchTerm: similarItemInfo.title,
        };

        const request = makeGet({
            apiPath: 'similaritems-v3',
            authToken,
            deployment,
            path: '<SEARCH-API>',
            queryParams: {
                houseId: similarItemInfo.sellerId,
                ids: JSON.stringify(similarItemInfo.categoryIds),
                itemId: similarItemInfo.itemId,
                parameters: JSON.stringify(params),
            },
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
/**
 * fetches SOLD similar items via Get to Search API
 * @function fetchSimilarSoldItemsV3
 * @category Search API
 * @param {FetchSimilarItemsParams}
 * @see https://api-DEPLOYMENT.liveauctioneers.com/search/similarsolditems
 * @see https://console.aws.amazon.com/apigateway/home?region=us-east-1#/apis/p8swwvetjb/resources/l1y02d/methods/GET
 * @see https://github.com/LIVEauctioneers/search-party/blob/master/functions/SimilarSoldItems/main.go
 */
const fetchSimilarSoldItemsV3 = ({
    authToken,
    deployment,
    similarItemInfo,
    /* eslint-disable-next-line */
    searchExclusions = [],
}: FetchSimilarItemsParams) =>
    new Promise<any>((resolve, reject) => {
        const { categoryIds = [], itemId: lotId, pageSize = 16, sellerId: houseId, title } = similarItemInfo;

        // houseId - houseId for the house that listed the item (optional)
        // ids - comma separated list of categoryIds for the item (optional)
        // lotId - the current item we are looking for similar items for
        // page - page to return (optional) defaults to 1, probably never needed
        // pageSize - max number of items to return (optional) defaults to 16
        // title - url encoded title of the current item (required)

        const ids = categoryIds.join(',');

        const request = makeGet({
            apiPath: 'similarsolditems',
            authToken,
            deployment,
            path: '<SEARCH-API>',
            queryParams: {
                houseId,
                ids,
                lotId,
                // page - not currently passing this because we are only using the first few
                pageSize,
                title,
            },
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

export default {
    fetchSimilarItemsV3,
    fetchSimilarSoldItemsV3,
};
